/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import { FormApi } from 'final-form';
import cn from 'classnames';

import { lodashGet } from 'functions/lodashGet';
import { Button } from 'UIPackage/MainModule/components/Button';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { FieldMark } from 'KnmPackage/MainModule/components/FieldMark/FieldMark';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';

import styles from './AttachmentsInModals.module.scss';

interface IAttachmentsInModalsProps {
  formRef: React.MutableRefObject<FormApi<any, Partial<any>> | undefined>;
  title: string;
  name: string;
  formats: string;
  disabled?: boolean;
  type?: 'one';
  hideButtonAdd?: boolean;
}

export const AttachmentsInModals = memo(
  ({ name, formats, title, formRef, disabled, type, hideButtonAdd }: IAttachmentsInModalsProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <FieldBlock
        className={cn({
          [styles.FieldBlockOne]: type === 'one',
          [styles.FieldBlock]: type !== 'one',
        })}
        label={
          <div className={styles.TitleWrapper}>
            <span className={styles.Title}>
              <FieldMark fieldName={name} label={title} />
              {type !== 'one' && (
                <Button
                  className={'shared-btn-add'}
                  text="Добавить"
                  variant="link"
                  color="primary"
                  type="button"
                  disabled={disabled}
                  onClick={openSignModal}
                />
              )}
            </span>
            <FormSpy subscription={{ errors: true, touched: true }}>
              {props => {
                if (props.errors?.[name]) {
                  const fieldError = lodashGet(props.errors, name);
                  const errorMessage: string | undefined = fieldError
                    ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
                    : undefined;

                  if (errorMessage && props.touched?.[name]) {
                    return <p className="shared-input-error">Поле не может быть пустым</p>;
                  }
                }

                return null;
              }}
            </FormSpy>
          </div>
        }
        placementLabel="left"
        color="black"
      >
        {!hideButtonAdd && type === 'one' && (
          <div>
            <Button
              className={'shared-btn-add'}
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              disabled={disabled}
              onClick={openSignModal}
            />
          </div>
        )}
        <KnmAttachmentsSigning
          formRef={formRef}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          acceptedFiles={formats}
          name={name}
        />
      </FieldBlock>
    );
  },
);
